/* eslint-disable react/prop-types */
import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import Theme from "../../../theme/theme";
import { StyledErrorMessage } from "./styles";

export interface ErrorMessageProps {
  message: string;
}

export const ErrorMessage: FunctionComponent<ErrorMessageProps> = ({
  message,
}) => (
  <Theme>
    <StyledErrorMessage aria-label={message}>{message}</StyledErrorMessage>
  </Theme>
);

ErrorMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ErrorMessage;
